export const BASE_URL = process.env.RAZZLE_BASE_URL
export const BASE_API_URL = process.env.RAZZLE_BASE_API_URL

export const AVAILABILITIES_API_END_POINT = process.env.RAZZLE_AVAILABILITIES_API_END_POINT || 'ical-availabilitys'
export const OPTIONS_OF_PRODUCT_API_END_POINT = process.env.RAZZLE_OPTIONS_OF_PRODUCT_API_END_POINT || 'option-of-products'
export const CART_ITEMS_API_END_POINT = process.env.RAZZLE_CART_ITEMS_API_END_POINT || 'cartitems'
export const RESERVATION_OPTION_UUID = process.env.RAZZLE_RESERVATION_OPTION_UUID

export const RESERVATION_REDIRECT_AFTER_ADD_TO_SHPPING_CART_URL = process.env.RAZZLE_RESERVATION_REDIRECT_AFTER_ADD_TO_SHPPING_CART_URL

export const AVAILABILITY_FILTER_USE_TIME = process.env.RAZZLE_AVAILABILITY_FILTER_USE_TIME || false
export const AVAILABILITY_DATE_STRING_FORMAT = AVAILABILITY_FILTER_USE_TIME ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD'
